import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'app-common-audit-update-task',
  templateUrl: './common-audit-update-task.component.html',
  styleUrls: ['../parts.css']
})
export class CommonAuditUpdateTaskComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据

  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipe;
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  categorieId: string; // 存放当前目录ID
  backFillData: any;
  automation = {
    boardId: '',
    boardConditionId: '',
    boardConditionName: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    itemId: '',
    itemName: '',
    auditStatus: '',
    instanceDescription: '',
    taskMapping: {}
  }; // 存放入参数据
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
    this.packageData();
  }
  // 组件提交数据
  packageData() {
    this.automation.instanceDescription = '监听到关联的稽核状态为正常时，自动完成任务。';
    this.nfDataChange.emit(this.automation);
  }
  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return true;
  }
}
